import { defineStore } from "pinia";
import { file } from "paths.macro";
import { useDeviceStore } from "@/stores/device";
import { useCatalogsStore } from "@/stores/catalogs";
import { CURRENT_PRODUCT } from "@/utils/build-config";
import { myAxiosRetry } from "@/services/myAxios";
import { getENPADPPrice, getENPPrice, getTotalPrice } from "@/helpers/api";
import { eventBus } from "@/main";
import { useMomentaryStore } from "@/stores/momentary";

export const useCartStore = defineStore("cart", {
  state: () => ({
    cart: [],
    adpCart: [],
    enpCart: [],
    cellPrices: [],
    enpPrices: [],
    adpPrices: [],
    totalPrice: {
      price: 0,
      NET: 0,
      ADD: 0,
      EURO: 0,
      RUB: 0,
      GBP: 0,
      agreementRUB: 0,
      agreementUSD: 0,
      agreementEURO_RU: 0,
      priceDisplay: 0,
      priceGP: 0,
    },
    adpTotalPrice: 0,
    enpTotalPrice: 0,
    priceRequestId: 0,
  }),
  getters: {
    getCart: (state) => state.cart,
    getADPCart: (state) => state.adpCart,
    getENPCart: (state) => state.enpCart,
    getCartLength: (state) => state.cart.length,
    getADPCartLength: (state) =>
      state.adpCart.filter((item) => !item.disabled).length,
    getENPCartLength: (state) =>
      state.enpCart.filter((item) => !item.disabled).length,
    getCellPrice: (state) => {
      return (id) => {
        let deviceStore = useDeviceStore();
        let currency = deviceStore.getAgreementCurrency;
        let agreementId = deviceStore.getAgreementID;
        console.log("EEEE agreementId", agreementId);

        let cellPrice = "?";
        let objIndex = state.cellPrices.findIndex((obj) => obj.id === id);

        if (objIndex !== -1) {
          if (agreementId === "-1") {
            cellPrice = state.cellPrices[objIndex].priceEuro;
          } else {
            if (currency === "USD")
              cellPrice = state.cellPrices[objIndex].priceAgreementUsd;

            if (currency === "RUB")
              cellPrice = state.cellPrices[objIndex].priceAgreementRub;
          }
        }

        return cellPrice;
      };
    },

    getADPPrice: (state) => {
      return (id) => {
        let adpPrice = "?";
        let objIndex = state.adpPrices.findIndex((obj) => obj.id === id);

        if (objIndex !== -1) {
          adpPrice = state.adpPrices[objIndex].priceGBP;
        }

        return adpPrice;
      };
    },

    getENPPrice: (state) => {
      return (id) => {
        let enpPrice = "?";
        let objIndex = state.enpPrices.findIndex((obj) => obj.id === id);

        if (objIndex !== -1) {
          enpPrice = state.enpPrices[objIndex].priceGBP;
        }

        return enpPrice;
      };
    },

    getENPTotalPrice: (state) => Number(state.enpTotalPrice),
    getADPTotalPrice: (state) => Number(state.adpTotalPrice),

    getTotalPrice: (state) => {
      let deviceStore = useDeviceStore();
      let agreementId = deviceStore.getAgreementID;
      let currency = deviceStore.getAgreementCurrency;
      console.log(
        "calculatePrice agreementId",
        agreementId,
        ", currency =",
        currency
      );

      if (currency === "USD") return state.totalPrice.agreementUSD;
      else if (currency === "RUB") return state.totalPrice.agreementRUB;
      else if (currency === "EUR") return state.totalPrice.EURO;
      else return undefined;
    },
  },
  actions: {
    clear() {
      this.cart = [];
      this.adpCart = [];
      this.enpCart = [];
      this.cellPrices = [];
      this.clearTotalPrice();
    },
    clearTotalPrice() {
      this.totalPrice.price = 0;
      this.totalPrice.NET = 0;
      this.totalPrice.ADD = 0;
      this.totalPrice.EURO = 0;
      this.totalPrice.RUB = 0;
      this.totalPrice.agreementRUB = 0;
      this.totalPrice.agreementUSD = 0;
      this.totalPrice.agreementEURO_RU = 0;
      this.totalPrice.priceDisplay = 0;
      this.totalPrice.priceGP = 0;
      // this.adpTotalPrice = 0
      // this.enpTotalPrice = 0
    },

    // Метод для сброса только ENP цены
    clearENPPrice() {
      this.enpTotalPrice = 0;
      this.enpPrices = [];
    },

    // Метод для сброса только ADP цены
    clearADPPrice() {
      this.adpTotalPrice = 0;
      this.adpPrices = [];
    },

    // Метод для сброса всех цен
    clearAllPrices() {
      this.clearTotalPrice();
      this.clearENPPrice();
      this.clearADPPrice();
      this.cellPrices = [];
    },

    addENPByRoute() {
      let catalogsStore = useCatalogsStore();
      const momentaryStore = useMomentaryStore();

      let enpByRoute = momentaryStore.getENPByRoute;
      console.log("pubs enpByRoute", enpByRoute);

      catalogsStore.getENP.products.forEach((item) => {
        // console.log("pubs add1", item.id)
        if (enpByRoute.includes(item.id)) {
          console.log("pubs add2", item.id);

          this.enpCart.push({
            id: item.id,
            name: item.title,
            disabled: false,
            periods: [3],
          });
        }
      });
    },

    addADPByRoute() {
      let catalogsStore = useCatalogsStore();
      const momentaryStore = useMomentaryStore();

      let adpByRoute = momentaryStore.getADPByRoute;
      console.log("pubs1 adpByRoute", adpByRoute);

      // console.log("pubs2 adpByRoute", catalogsStore.getADP)
      // console.log("pubs3 adpByRoute", catalogsStore.getADP.products)

      let adp1 = catalogsStore.getADP1.products;
      let adp2 = catalogsStore.getADP2.products;
      let adp3 = catalogsStore.getADP3.products;

      console.log("abcd1", adp1);
      console.log("abcd2", adp2);
      console.log("abcd3", adp3);

      let adp = {};
      adp.products = [...adp1, ...adp2, ...adp3];

      console.log("abcd", adp);

      adp.products.forEach((item) => {
        // console.log("pubs add1", item.id)
        if (adpByRoute.includes(item.id)) {
          console.log("pubs add2", item.id);

          this.adpCart.push({
            id: item.id,
            name: item.title,
            disabled: false,
            periods: [3],
          });
        }
      });
    },

    addAllPublications() {
      let catalogsStore = useCatalogsStore();
      const momentaryStore = useMomentaryStore();

      let adpByRoute = momentaryStore.getADPByRoute;
      let enpByRoute = momentaryStore.getENPByRoute;

      catalogsStore.getENP.products.forEach((item) => {
        let disabled = true;
        if (enpByRoute.find((a) => a.id === item.id)) {
          disabled = false;
        }

        this.enpCart.push({
          id: item.id,
          name: item.title,
          disabled: disabled,
          periods: [3],
        });
      });

      console.log("adp 1", catalogsStore.getADP1.products);
      console.log("adp 2", catalogsStore.getADP2.products);
      console.log("adp 3", catalogsStore.getADP3.products);
      console.log("adp ", adpByRoute);

      catalogsStore.getADP1.products.forEach((item) => {
        let disabled = true;
        if (adpByRoute.find((a) => a.id === item.title)) {
          disabled = false;
        }

        this.adpCart.push({
          id: item.id,
          name: item.title,
          disabled: disabled,
          periods: [3],
        });
      });
      catalogsStore.getADP2.products.forEach((item) => {
        let disabled = true;
        if (adpByRoute.find((a) => a.id === item.title)) {
          disabled = false;
        }

        this.adpCart.push({
          id: item.id,
          name: item.title,
          disabled: disabled,
          periods: [3],
        });
      });
      catalogsStore.getADP3.products.forEach((item) => {
        let disabled = true;
        if (adpByRoute.find((a) => a.id === item.title)) {
          disabled = false;
        }

        this.adpCart.push({
          id: item.id,
          name: item.title,
          disabled: disabled,
          periods: [3],
        });
      });
    },

    addCells(keysList, append = false) {
      let catalogStore = useCatalogsStore();
      let deviceStore = useDeviceStore();

      return new Promise((resolve) => {
        const allItems = catalogStore.getProducts;
        let newItems = [];
        let processedKeys = new Set(); // Для отслеживания уже обработанных ключей в этой операции

        keysList.forEach((key) => {
          // Проверяем, уже ли мы обрабатывали этот ключ в этой операции
          if (processedKeys.has(key)) {
            console.warn("addCells: duplicate in import list:", key);
            return;
          }

          // Проверяем, есть ли карта уже в корзине
          if (this.cart.find((obj) => obj.id === key)) {
            console.warn("addCells: cell already in cart:", key);
            return;
          }

          let item = allItems.find((obj) => {
            return obj.id == key;
          });

          // Проверяем что item существует
          if (item) {
            processedKeys.add(key);
            newItems.push(item);
          } else {
            console.warn("addCells: cell not found in catalog:", key);
          }
        });

        let CartItems = [];
        newItems.forEach((item) => {
          // ДОПОЛНИТЕЛЬНАЯ ПРОВЕРКА: убеждаемся что item не undefined
          if (!item) {
            console.error("addCells: attempted to process undefined item");
            return; // пропускаем этот элемент
          }

          const countryInfo = catalogStore.getCountries.find(
            (x) => x.id === item.countryId
          );
          let subTypes;
          if (countryInfo) {
            subTypes =
              countryInfo.possibleSubscriptionTypeList
                .possibleSubscriptionTypes;
          } else {
            //TODO
            subTypes = [{ id: 4 }];
          }

          let periods = [];
          subTypes.forEach((x) => {
            switch (x.id) {
              case 0:
                periods.push(12);
                break;
              case 1:
                periods.push(6);
                break;
              case 4:
                periods.push(3);
                break;
              default:
                break;
            }
          });
          CartItems.push({
            id: item.id,
            name: item.title,
            cells: item.id.startsWith("102")
              ? item.productDatasetList.productDatasets
              : item.productCellList.productCells,
            periods: periods,
            disabled: deviceStore.isStillValid(item.id),
          });
        });

        if (!append) this.cart = CartItems;
        else this.cart.push(...CartItems);

        console.log(
          "addCells: added to cart",
          CartItems.length,
          "of",
          keysList.length,
          "requested cells"
        );

        resolve(CartItems.length); // Возвращаем количество реально добавленных ячеек
      });
    },

    // Расширенная версия addCells с возвратом детальной статистики
    addCellsWithStats(keysList, append = false) {
      let catalogStore = useCatalogsStore();
      let deviceStore = useDeviceStore();

      return new Promise((resolve) => {
        const allItems = catalogStore.getProducts;
        let newItems = [];
        let notFoundCells = []; // Список ячеек, не найденных в каталоге
        let duplicateCells = []; // Список дубликатов
        let processedKeys = new Set(); // Для отслеживания уже обработанных ключей в этой операции

        keysList.forEach((key) => {
          // Проверяем, уже ли мы обрабатывали этот ключ в этой операции
          if (processedKeys.has(key)) {
            console.warn("addCellsWithStats: duplicate in import list:", key);
            duplicateCells.push(key);
            return;
          }

          // Проверяем, есть ли карта уже в корзине
          if (this.cart.find((obj) => obj.id === key)) {
            console.warn("addCellsWithStats: cell already in cart:", key);
            duplicateCells.push(key);
            return;
          }

          let item = allItems.find((obj) => {
            return obj.id == key;
          });

          if (item) {
            processedKeys.add(key);
            newItems.push(item);
          } else {
            console.warn("addCellsWithStats: cell not found in catalog:", key);
            notFoundCells.push(key);
          }
        });

        let CartItems = [];
        newItems.forEach((item) => {
          if (!item) {
            console.error(
              "addCellsWithStats: attempted to process undefined item"
            );
            return;
          }

          const countryInfo = catalogStore.getCountries.find(
            (x) => x.id === item.countryId
          );
          let subTypes;
          if (countryInfo) {
            subTypes =
              countryInfo.possibleSubscriptionTypeList
                .possibleSubscriptionTypes;
          } else {
            subTypes = [{ id: 4 }];
          }

          let periods = [];
          subTypes.forEach((x) => {
            switch (x.id) {
              case 0:
                periods.push(12);
                break;
              case 1:
                periods.push(6);
                break;
              case 4:
                periods.push(3);
                break;
              default:
                break;
            }
          });
          CartItems.push({
            id: item.id,
            name: item.title,
            cells: item.id.startsWith("102")
              ? item.productDatasetList.productDatasets
              : item.productCellList.productCells,
            periods: periods,
            disabled: deviceStore.isStillValid(item.id),
          });
        });

        if (!append) this.cart = CartItems;
        else this.cart.push(...CartItems);

        const stats = {
          totalRequested: keysList.length,
          added: CartItems.length,
          notFound: notFoundCells,
          duplicates: duplicateCells,
          skipped: notFoundCells.length + duplicateCells.length,
        };

        console.log("addCellsWithStats stats:", stats);

        resolve(stats);
      });
    },

    updateCell(payload) {
      let objIndex = this.cart.findIndex((obj) => obj.id === payload.id);
      if (payload.type === "switch")
        this.cart[objIndex].disabled = !this.cart[objIndex].disabled;

      if (payload.type === "on") this.cart[objIndex].disabled = false;

      if (payload.type === "off") this.cart[objIndex].disabled = true;

      // Возвращаем isSelected (!disabled), а не disabled
      return !this.cart[objIndex].disabled;
    },

    updateENP(payload) {
      let objIndex = this.enpCart.findIndex((obj) => obj.id === payload.id);
      if (payload.type === "switch")
        this.enpCart[objIndex].disabled = !this.enpCart[objIndex].disabled;

      if (payload.type === "on") this.enpCart[objIndex].disabled = false;

      if (payload.type === "off") this.enpCart[objIndex].disabled = true;

      // Возвращаем isSelected (!disabled), а не disabled
      return !this.enpCart[objIndex].disabled;
    },

    updateADP(payload) {
      console.log("adp UPDATE", payload);
      console.log("adp UPDATE", this.adpCart);
      let objIndex = this.adpCart.findIndex((obj) => obj.id === payload.id);

      console.log(objIndex);

      if (payload.type === "switch")
        this.adpCart[objIndex].disabled = !this.adpCart[objIndex].disabled;

      if (payload.type === "on") this.adpCart[objIndex].disabled = false;

      if (payload.type === "off") this.adpCart[objIndex].disabled = true;

      // Возвращаем isSelected (!disabled), а не disabled
      return !this.adpCart[objIndex].disabled;
    },

    calculatePrice({
      products,
      periodBand,
      agreementID,
      deviceID,
      appType,
      isManualCalculating = true,
    }) {
      // const caller = new Error().stack.split('\n')[2]?.trim() || 'unknown'
      // const caller1 = new Error().stack
      // console.warn(`DEPRECATED: calculatePrice is deprecated, use calculateTotalPrice instead. Called by: ${caller1}`)
      // alert('calculatePrice is deprecated, use calculateTotalPrice instead')
      let deviceStore = useDeviceStore();
      let provider = deviceStore.getAgreementProvider;
      let requestId = this.priceRequestId++;

      if (!provider) provider = "Primar";
      // if (!agreementID) agreementID = "";
      if (!appType) appType = "11";

      return new Promise((resolve, reject) => {
        if (products.length > 0 && periodBand) {
          let items = [];
          console.log("calculatePrice: received products:", products.length, "items", products.map(x => ({ id: x.id, disabled: x.disabled })));
          
          products.forEach((x) => {
            if (!x.disabled) items.push(x.id);
          });

          console.log("calculatePrice: filtered items for price calculation:", items);

          let quotate = {};

          // if (provider === 'UKHO') {
          //   let months = 3
          //   if (periodBand === '1') months = 6
          //   if (periodBand === '0') months = 12

          //   quotate = {
          //     cells: items,
          //     monthCount: months,
          //   }
          // }
          console.log("calculatePrice provider", provider);

          if (provider === "Primar" || provider === "") {
            quotate = {
              items: items,
              subscriptionType: periodBand,
              agreementId: agreementID,
              deviceId: deviceID,
              applicationTypeId: appType,
              quotateManually: false,
              //isManualCalculating
            };
          }

          // let URL = "/api/v1/orders/primar/quotate/v3"
          // if (provider === 'UKHO') {
          //     URL = "api/v1/mss/avcquotate"
          // }

          // myAxiosRetry.post(URL, quotate).then(resp => {
          getTotalPrice(provider, quotate, requestId)
            .then((resp) => {
              let usdPrice = 0;
              // if (provider === "UKHO") {
              //   resp.data.uoses.forEach((item) => {
              //     usdPrice += item.price;
              //   });

              //   this.clearTotalPrice();
              //   this.totalPrice.agreementUSD = Number(usdPrice).toFixed(2);
              //   this.totalPrice.displayPrice = Number(usdPrice).toFixed(2);

              //   this.cellPrices = [];
              //   resp.data.uoses.forEach((item) => {
              //     let cellPriceEuro = 0;
              //     let cellPriceRub = 0;
              //     let cellPriceAgreementUsd = Number(
              //       Number(item.price).toFixed(2)
              //     );
              //     let cellPriceAgreementRub = 0;
              //     this.cellPrices.push({
              //       id: item.name,
              //       priceEuro: cellPriceEuro,
              //       priceRub: cellPriceRub,
              //       priceAgreementUsd: cellPriceAgreementUsd,
              //       priceAgreementRub: cellPriceAgreementRub,
              //     });
              //   });
              // }

              if (provider === "Primar" || provider === "") {
                this.clearTotalPrice();
                this.totalPrice.EURO = Number(
                  Number(resp.data.userEuro).toFixed(2)
                );
                this.totalPrice.RUB = Number(
                  Number(resp.data.userRub).toFixed(2)
                );
                this.totalPrice.ADD = Number(
                  Number(resp.data.userEuroAdd).toFixed(2)
                );
                this.totalPrice.NET = Number(
                  Number(resp.data.euroPrice).toFixed(2)
                );
                this.totalPrice.agreementUSD = Number(
                  Number(resp.data.agreementUsd).toFixed(2)
                );
                this.totalPrice.agreementRUB = Number(
                  Number(resp.data.agreementRub).toFixed(2)
                );
                this.totalPrice.displayPrice = Number(
                  Number(resp.data.displayPrice).toFixed(2)
                );

                this.cellPrices = [];
                resp.data.itemsPrice.forEach((item) => {
                  let cellPriceEuro = Number(Number(item.userEuro).toFixed(2));
                  let cellPriceRub = Number(Number(item.userRub).toFixed(2));
                  let cellPriceAgreementUsd = Number(
                    Number(item.agreementUsd).toFixed(2)
                  );
                  let cellPriceAgreementRub = Number(
                    Number(item.agreementRub).toFixed(2)
                  );
                  this.cellPrices.push({
                    id: item.id,
                    priceEuro: cellPriceEuro,
                    priceRub: cellPriceRub,
                    priceAgreementUsd: cellPriceAgreementUsd,
                    priceAgreementRub: cellPriceAgreementRub,
                  });
                });
              }
              resolve(this.totalPrice.price);
            })
            .catch((err) => {
              console.error("Error in calculatePrice:", err);
              eventBus.$emit("recalculate-total-price");
              reject(err); // Пробрасываем ошибку дальше для обработки в компоненте
            });
        } else {
          this.clearTotalPrice();
          resolve(0); // Возвращаем 0 когда нет товаров для расчета
        }
      });
    },
    calculateENPPrice({
      products,
      periodBand,
      agreementID,
      deviceID,
      appType,
      isManualCalculating = true,
    }) {
      let requestId = this.priceRequestId++;

      return new Promise((resolve) => {
        if (products.length > 0 && periodBand) {
          let quotate = [];
          products.forEach((x) => {
            if (!x.disabled) quotate.push(x.id);
          });

          getENPADPPrice(quotate, requestId)
            .then((resp) => {
              console.log("enp resp");
              console.log("enp resp.data.price", resp.data.uoses);

              let gbpPrice = 0;
              resp.data.uoses.forEach((item) => {
                gbpPrice += item.price;
              });

              console.log("enp gbpPrice", gbpPrice);

              console.log("enp1_", this.enpTotalPrice);
              this.enpTotalPrice = Number(gbpPrice);
              console.log("enp2_", this.enpTotalPrice);

              this.enpPrices = [];
              resp.data.uoses.forEach((item) => {
                let cellPriceAgreementGBP = Number(
                  Number(item.price).toFixed(2)
                );
                this.enpPrices.push({
                  id: item.name,
                  priceGBP: cellPriceAgreementGBP,
                });
              });
              resolve(this.enpTotalPrice);
            })
            .catch((err) => {
              // eventBus.$emit('recalculate-enp-price')
            });
        } else {
          this.clearTotalPrice();
        }
      });
    },
    calculateADPPrice({
      products,
      periodBand,
      agreementID,
      deviceID,
      appType,
      isManualCalculating = true,
    }) {
      let requestId = this.priceRequestId++;

      console.log("adp ADP", products);

      return new Promise((resolve) => {
        if (products.length > 0 && periodBand) {
          let quotate = [];
          products.forEach((x) => {
            if (!x.disabled) quotate.push(x.name);
          });

          getENPADPPrice(quotate, requestId)
            .then((resp) => {
              console.log("adp resp");
              console.log("adp resp.data.price", resp.data.uoses);

              let gbpPrice = 0;
              resp.data.uoses.forEach((item) => {
                gbpPrice += item.price;
              });

              console.log("adp gbpPrice", gbpPrice);

              console.log("adp1_", this.enpTotalPrice);
              this.adpTotalPrice = Number(gbpPrice);
              console.log("adp2_", this.enpTotalPrice);

              this.adpPrices = [];
              resp.data.uoses.forEach((item) => {
                let cellPriceAgreementGBP = Number(
                  Number(item.price).toFixed(2)
                );
                this.adpPrices.push({
                  id: item.name,
                  priceGBP: cellPriceAgreementGBP,
                });
              });
              resolve(this.adpTotalPrice);
            })
            .catch((err) => {
              // eventBus.$emit('recalculate-adp-price')
            });
        } else {
          this.clearTotalPrice();
        }
      });
    },
    reset() {},
  },
  persist: false,
});
